import { Inject, LOCALE_ID, Pipe, PipeTransform } from "@angular/core";
import { formatDate } from "@angular/common";

@Pipe({
  name: 'dateTransform'
})
export class DateTransformPipe implements PipeTransform {

  constructor(@Inject(LOCALE_ID) private locale: string) {
  }

  transform(value: any, mode: 'timestamp' | 'dateOnly' | 'std' | 'dateWithHyphen' | 'datetimeWithHyphen' | 'timeOnly' | 'monthYear'| 'convertFrom24To12Format' | 'none' = 'dateOnly') {
    try {
      if (!value) {
        return null;
      }
      if (mode === 'timestamp') {
        return formatDate(value, 'MM/dd/yyyy hh:mm a', this.locale);
      } else if (mode === 'dateOnly') {
        return formatDate(value, 'MM/dd/yyyy', this.locale);
      } else if (mode === 'std') {
        return formatDate(value, 'dd/MM/yyyy', this.locale);
      } else if (mode === 'dateWithHyphen') {
        return formatDate(value, 'YYYY-MM-dd', this.locale);
      } else if (mode === 'datetimeWithHyphen') {
        return formatDate(value, 'yyyy-MM-dd HH:mm', this.locale);
      } else if (mode === 'timeOnly') {
        return formatDate(value, 'hh:mm a', this.locale);
      } else if (mode === 'monthYear') {
        const date = new Date(value);
        const month = date.toLocaleString('default', { month: 'short', year: '2-digit' });
        return month;
      } else if(mode === 'convertFrom24To12Format') {
        let hour = (value.split(':'))[0]
         let min = (value.split(':'))[1]
         let part = hour > 12 ? 'pm' : 'am';
         if(parseInt(hour) == 0)
          hour = 12;
         min = (min+'').length == 1 ? `0${min}` : min;
         hour = hour > 12 ? hour - 12 : hour;
         hour = (hour+'').length == 1 ? `0${hour}` : hour;
         return `${hour}:${min} ${part}`
      }
    } catch {
      return null;
    }
  }

}
